import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 特定職員数の見込数変更申請表示、更新
import {
  IAPI_FAC007_Request,
  IAPI_FAC007_Response,
  IAPI_FAC008_Request,
  IAPI_FAC008_Response,
} from "../../../type/apiType";

// 特定職員数の見込数変更申請表示
// API仕様書_施設
const httpIAPI_FAC007 = async (
  param: IAPI_FAC007_Request
): Promise<IAPI_FAC007_Response> => {
  let res = await http.post(ApiUrl.API_FAC007, {
    ...param,
  });

  return res.data;
};

// 特定職員数の見込数更新API
// API仕様書_施設
const httpIAPI_FAC008 = async (
  param: IAPI_FAC008_Request
): Promise<IAPI_FAC008_Response> => {
  let res = await http.post(ApiUrl.API_FAC008, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_FAC007, httpIAPI_FAC008 };
